/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */

import { FieldArray, Form, Formik } from 'formik';
import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import style from './ServiziForm.module.scss';
import { setServiziData } from '../../../../app/slices/serviziSlice';
import store from '../../../../app/store/store';
import api from '../../../../core/api';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../../../components/Buttons/SecondaryButton/SecondaryButton';
import ServiziTile from '../ServiziTile/ServiziTile';

function ServiziForm() {
  const [state, setState] = useState({});
  const [buttonText, setButtonText] = useState('Non voglio inserire altre informazioni');
  const initialValues = {
    servizi: [
      {
        idServizio: 0,
        servizio: 'Taglio',
        attivo: false,
      },
      {
        idServizio: 1,
        servizio: 'Barba',
        attivo: false,
      },
      {
        idServizio: 2,
        servizio: 'Trattamento Barba',
        attivo: false,
      },
      {
        idServizio: 3,
        servizio: 'Taglio e Barba',
        attivo: false,
      },
      {
        idServizio: 4,
        servizio: 'Trattamento cute',
        attivo: false,
      },
      {
        idServizio: 5,
        servizio: 'Servizi estetici',
        attivo: false,
      },
    ],
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNextStep = (values) => {
    dispatch(setServiziData(values));
    navigate('/poltrone');
  };
  const handleSendData = async (values) => {
    await dispatch(setServiziData(values));
    await setState({
      form: store.getState().form.form,
      giorni: store.getState().orari.giorni,
      servizi: store.getState().servizi.servizi,
      poltrone: store.getState().poltrone.poltrone,
    });
    api.post('/business/auth/autoSignUp', state).then((res) => (res.status === 200 ? navigate('/riepilogo') : setButtonText('Riprova')));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values) => {
        handleNextStep(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className={clsx(style.form)}>
          <div className={clsx(style.form__header)}>
            <h2 className={clsx(style.page__title)}>
              Servizi salone
            </h2>
            <h3 className={clsx(style.page__subtitle)}>
              Spunta tra questa lista i servizi che offre il tuo salone.
              <b>
                {' '}
                Nota bene questa è solo una configurazione standard. Successivamente potrai personalizzare tutti
                i tuoi servizi
              </b>
            </h3>

          </div>
          <div className={clsx(style.form__fields)}>
            <FieldArray name="servizi">
              {() => (
                values.servizi.map((servizio, index) => (
                  <ServiziTile
                    servizi={values.servizi}
                    setFieldValue={setFieldValue}
                    index={servizio.idServizio}
                    key={index}
                  />
                ))
              )}
            </FieldArray>
          </div>
          <div className={clsx(style.form__footer)}>
            <PrimaryButton type="submit" label="Avanti" fullWidth />
            <SecondaryButton type="button" label={buttonText} onClick={() => handleSendData(values)} fullWidth />
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default ServiziForm;
